(function() {
  if (window.KavalriExpeditedShippingBundleInitialized) {
    return;
  }

  window.KavalriExpeditedShippingBundleInitialized = true;

  var CONFIG = {
    bundleIdProperty: '_expedited_shipping_bundle_id',
    roleProperty: '_expedited_shipping_role',
    propertyNameProperty: '_expedited_shipping_property_name',
    mainRole: 'main',
    addonRole: 'addon',
    defaultPropertyName: 'Expedited shipping'
  };

  var state = {
    addToCartLoading: false,
    removeLoading: false,
    redirectingToCartPage: false
  };

  // Runs callbacks after the DOM is ready so the block can safely bind events.
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  // Normalizes week values from data attributes and falls back to 0 for invalid values.
  function parseWeek(value) {
    var parsedValue = parseInt(value, 10);
    return Number.isNaN(parsedValue) ? 0 : parsedValue;
  }

  // Converts a week offset into the customer-facing completion date string.
  function formatCompletionDate(week) {
    var currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + (week * 7));

    var day = String(currentDate.getDate()).padStart(2, '0');
    var month = currentDate.toLocaleDateString('en-US', { month: 'long' });
    var year = currentDate.getFullYear();

    return day + ' ' + month + ', ' + year;
  }

  // Creates a unique id used to link the main product and expedited addon in cart.
  function buildBundleId() {
    return 'expedited-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  // Reads the visible line item property label from the block configuration.
  function getPropertyName(block) {
    return block.dataset.expeditedPropertyName || CONFIG.defaultPropertyName;
  }

  // Reads the requested quantity from the product form and guarantees a minimum of 1.
  function getQuantity(formData) {
    var quantity = parseInt(formData.get('quantity') || '1', 10);
    return Number.isNaN(quantity) || quantity < 1 ? 1 : quantity;
  }

  // Finds the active add to cart button for loading state control.
  function getAddToCartButton(form) {
    return form.querySelector('[data-add-to-cart]');
  }

  // Toggles button loading UI while asynchronous cart requests are in flight.
  function setButtonLoading(button, loading) {
    if (!button) {
      return;
    }

    button.classList.toggle('btn--loading', loading);
    button.disabled = loading;
  }

  // Injects a single inline form error message for expedited add to cart failures.
  function renderFormError(form, message) {
    if (!form || !message) {
      return;
    }

    var existingError = form.querySelector('.errors');
    if (existingError) {
      existingError.remove();
    }

    var errorDiv = document.createElement('div');
    errorDiv.className = 'errors text-center';
    errorDiv.textContent = message;
    form.appendChild(errorDiv);
  }

  // Removes any previously rendered inline form error from the product form.
  function clearFormError(form) {
    if (!form) {
      return;
    }

    var existingError = form.querySelector('.errors');
    if (existingError) {
      existingError.remove();
    }
  }

  // Extracts line item properties from FormData so they can be preserved in bundled adds.
  function extractLineItemProperties(formData) {
    var properties = {};

    formData.forEach(function(value, key) {
      var propertyMatch = key.match(/^properties\[(.+)\]$/);
      if (!propertyMatch || value === '') {
        return;
      }

      properties[propertyMatch[1]] = value;
    });

    return properties;
  }

  // Resolves the theme cart add endpoint with a Shopify fallback.
  function getCartAddUrl() {
    return window.theme && theme.routes && theme.routes.cartAdd ? theme.routes.cartAdd : '/cart/add.js';
  }

  // Resolves the cart page URL with a Shopify fallback.
  function getCartPageUrl() {
    return window.theme && theme.routes && theme.routes.cartPage ? theme.routes.cartPage : '/cart';
  }

  // Gets the closest product section so DOM updates stay scoped to the current product.
  function getProductSection(block) {
    return block ? block.closest('.product-section') : null;
  }

  // Finds the primary product price node that should reflect the expedited surcharge.
  function getProductPriceElement(block) {
    var productSection = getProductSection(block);
    if (!productSection) {
      return null;
    }

    return productSection.querySelector('.product-block--price__price [data-product-price]') ||
      productSection.querySelector('.product-block--price__price .product__price:not(.product__price--compare)');
  }

  // Resolves the expedited radio inputs using the rendered id prefix instead of hard-coded ids.
  function getExpeditedOptions(block) {
    if (!block) {
      return {
        freeOption: null,
        urgentOption: null
      };
    }

    return {
      freeOption: block.querySelector('input[id^="Expedited-Crafting-free-"]'),
      urgentOption: block.querySelector('input[id^="Expedited-Crafting-urgent-"]')
    };
  }

  // Parses a money-like string into cents so formatted dataset values can be added safely.
  function parseMoneyToCents(value) {
    if (value == null) {
      return 0;
    }

    if (typeof value === 'number' && Number.isFinite(value)) {
      return Math.round(value);
    }

    var normalizedValue = String(value).trim();
    if (!normalizedValue) {
      return 0;
    }

    normalizedValue = normalizedValue.replace(/\s/g, '').replace(/[^0-9,.\-]/g, '');

    if (!normalizedValue) {
      return 0;
    }

    var lastCommaIndex = normalizedValue.lastIndexOf(',');
    var lastDotIndex = normalizedValue.lastIndexOf('.');
    var decimalSeparator = lastCommaIndex > lastDotIndex ? ',' : '.';
    var separatorIndex = Math.max(lastCommaIndex, lastDotIndex);
    var hasDecimalSeparator = separatorIndex !== -1;

    if (hasDecimalSeparator) {
      var decimalDigits = normalizedValue.length - separatorIndex - 1;

      if (decimalDigits > 0 && decimalDigits <= 2) {
        var integerPart = normalizedValue.slice(0, separatorIndex).replace(/[.,]/g, '');
        var decimalPart = normalizedValue.slice(separatorIndex + 1).replace(/[.,]/g, '');
        var decimalValue = Number(integerPart + '.' + decimalPart);

        return Number.isNaN(decimalValue) ? 0 : Math.round(decimalValue * 100);
      }
    }

    var wholeNumberValue = parseInt(normalizedValue.replace(/[.,]/g, ''), 10);
    return Number.isNaN(wholeNumberValue) ? 0 : wholeNumberValue * 100;
  }

  // Formats cents using the theme currency formatter and falls back to a plain decimal string.
  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }

    return String((cents / 100).toFixed(2));
  }

  // Reads and parses the expedited surcharge stored on the block dataset.
  function getAddonPriceCents(block) {
    return parseMoneyToCents(block && block.dataset ? block.dataset.expeditedUrgentprice : '');
  }

  // Caches the variant JSON from the form so repeated price lookups stay inexpensive.
  function getVariants(form) {
    if (!form) {
      return [];
    }

    if (form._expeditedVariantsCache) {
      return form._expeditedVariantsCache;
    }

    var variantsJson = form.querySelector('[data-variant-json]');
    if (!variantsJson) {
      return [];
    }

    try {
      form._expeditedVariantsCache = JSON.parse(variantsJson.textContent);
    } catch (error) {
      form._expeditedVariantsCache = [];
    }

    return form._expeditedVariantsCache;
  }

  // Returns the selected variant price in cents, falling back to the current DOM price.
  function getCurrentVariantPriceCents(form, block) {
    if (form) {
      var variantSelect = form.querySelector('select[name="id"]');
      var selectedVariantId = variantSelect ? String(variantSelect.value) : '';
      var variants = getVariants(form);
      var matchedVariant = variants.find(function(variant) {
        return String(variant.id) === selectedVariantId;
      });

      if (matchedVariant && typeof matchedVariant.price === 'number') {
        return matchedVariant.price;
      }
    }

    var priceElement = getProductPriceElement(block);
    return priceElement ? parseMoneyToCents(priceElement.textContent) : 0;
  }

  // Re-renders the main product price with or without the expedited surcharge applied.
  function syncDisplayedPrice(block, basePriceCents) {
    var priceElement = getProductPriceElement(block);
    var urgentOption = getExpeditedOptions(block).urgentOption;

    if (!priceElement || !urgentOption) {
      return;
    }

    var form = block.closest('form');
    var nextBasePrice = typeof basePriceCents === 'number' ? basePriceCents : getCurrentVariantPriceCents(form, block);
    var nextDisplayedPrice = urgentOption.checked ? nextBasePrice + getAddonPriceCents(block) : nextBasePrice;

    priceElement.innerHTML = formatMoney(nextDisplayedPrice);
  }

  // Adds the main item and expedited addon together so they share the same bundle metadata.
  async function addBundledItems(form, block) {
    var formData = new FormData(form);
    var mainVariantId = formData.get('id');
    var addonVariantId = block.dataset.expeditedCraftingVariantid;
    var urgentOption = getExpeditedOptions(block).urgentOption;
    var propertyName = getPropertyName(block);

    if (!mainVariantId || !addonVariantId || !urgentOption) {
      throw new Error('Expedited shipping is not configured correctly.');
    }

    var bundleId = buildBundleId();
    var quantity = getQuantity(formData);
    var mainProperties = extractLineItemProperties(formData);
    var addonProperties = {};

    mainProperties[propertyName] = urgentOption.value || propertyName;
    mainProperties[CONFIG.bundleIdProperty] = bundleId;
    mainProperties[CONFIG.roleProperty] = CONFIG.mainRole;
    mainProperties[CONFIG.propertyNameProperty] = propertyName;

    addonProperties[CONFIG.bundleIdProperty] = bundleId;
    addonProperties[CONFIG.roleProperty] = CONFIG.addonRole;
    addonProperties[CONFIG.propertyNameProperty] = propertyName;

    var response = await fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: mainVariantId,
            quantity: quantity,
            properties: mainProperties
          },
          {
            id: addonVariantId,
            quantity: quantity,
            properties: addonProperties
          }
        ]
      })
    });

    var responseData = await response.json();

    if (!response.ok || responseData.status) {
      throw new Error(responseData.description || 'Unable to add expedited shipping.');
    }

    return responseData;
  }

  // Updates the completion date copy based on the currently selected shipping option.
  function updateCompletionDate(block) {
    var options = getExpeditedOptions(block);
    var freeOption = options.freeOption;
    var urgentOption = options.urgentOption;
    var completionDate = block.querySelector('#completion-date');

    if (!freeOption || !urgentOption || !completionDate) {
      return;
    }

    var freeWeek = parseWeek(block.dataset.expeditedCraftingFreeweek);
    var urgentWeek = parseWeek(block.dataset.expeditedCraftingUrgentweek);

    if (!freeOption.checked && !urgentOption.checked) {
      freeOption.checked = true;
    }

    completionDate.textContent = formatCompletionDate(urgentOption.checked ? urgentWeek : freeWeek);
  }

  // Initializes one expedited block, binds option events, and intercepts bundled add to cart.
  function initProductBlock(block) {
    if (!block || block.dataset.expeditedBundleReady === 'true') {
      return;
    }

    var form = block.closest('form');
    var productSection = getProductSection(block);
    if (!form) {
      return;
    }

    block.dataset.expeditedBundleReady = 'true';

    var options = getExpeditedOptions(block);
    var freeOption = options.freeOption;
    var urgentOption = options.urgentOption;

    updateCompletionDate(block);
    syncDisplayedPrice(block);

    if (freeOption) {
      freeOption.addEventListener('change', function() {
        updateCompletionDate(block);
        syncDisplayedPrice(block);
      });
    }

    if (urgentOption) {
      urgentOption.addEventListener('change', function() {
        updateCompletionDate(block);
        syncDisplayedPrice(block);
      });
    }

    if (productSection) {
      productSection.addEventListener('variantChange', function(event) {
        if (!event.detail || !event.detail.variant || typeof event.detail.variant.price !== 'number') {
          syncDisplayedPrice(block);
          return;
        }

        syncDisplayedPrice(block, event.detail.variant.price);
      });
    }

    form.addEventListener('submit', function(event) {
      if (!urgentOption || !urgentOption.checked || state.addToCartLoading) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      var addToCartButton = getAddToCartButton(form);
      state.addToCartLoading = true;
      setButtonLoading(addToCartButton, true);
      clearFormError(form);

      addBundledItems(form, block)
        .then(function(responseData) {
          var addedProduct = responseData.items && responseData.items.length ? responseData.items[0] : responseData;

          if (document.body.classList.contains('template-cart')) {
            window.location.reload();
            return;
          }

          if (window.theme && theme.settings && theme.settings.cartType === 'drawer') {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: addedProduct,
                addToCartBtn: addToCartButton
              }
            }));
            return;
          }

          window.location.href = getCartPageUrl();
        })
        .catch(function(error) {
          renderFormError(form, error.message || 'Unable to add expedited shipping.');
        })
        .finally(function() {
          state.addToCartLoading = false;
          setButtonLoading(addToCartButton, false);
        });
    }, true);
  }

  // Bootstraps every expedited block rendered on the current page.
  function initProductBlocks() {
    document.querySelectorAll('.expedited-crafting__block').forEach(initProductBlock);
  }

  // Safely returns line item properties from a cart item.
  function getBundleProperties(item) {
    return item && item.properties ? item.properties : {};
  }

  // Extracts the bundle id used to relate main and addon line items.
  function getBundleId(item) {
    return getBundleProperties(item)[CONFIG.bundleIdProperty];
  }

  // Reads whether a bundled cart item is the main product or the addon item.
  function getBundleRole(item) {
    return getBundleProperties(item)[CONFIG.roleProperty];
  }

  // Returns the visible property label used when the expedited choice is shown in cart.
  function getVisiblePropertyName(item) {
    return getBundleProperties(item)[CONFIG.propertyNameProperty] || CONFIG.defaultPropertyName;
  }

  // Removes internal expedited metadata before rebuilding the standalone main cart item.
  function stripExpeditedProperties(properties) {
    var sanitizedProperties = {};
    var visiblePropertyName = properties[CONFIG.propertyNameProperty] || CONFIG.defaultPropertyName;

    Object.keys(properties || {}).forEach(function(key) {
      if (
        key === visiblePropertyName ||
        key === CONFIG.bundleIdProperty ||
        key === CONFIG.roleProperty ||
        key === CONFIG.propertyNameProperty
      ) {
        return;
      }

      if (properties[key] !== '' && properties[key] != null) {
        sanitizedProperties[key] = properties[key];
      }
    });

    return sanitizedProperties;
  }

  // Posts a cart change request to Shopify using the theme route when available.
  function postCartChange(payload) {
    var changeUrl = window.theme && theme.routes && theme.routes.cartChange ? theme.routes.cartChange : '/cart/change.js';

    return fetch(changeUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    }).then(function(response) {
      return response.json();
    });
  }

  // Posts a cart add request and throws a normalized error when Shopify rejects it.
  function postCartAdd(payload) {
    return fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    }).then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || 'Unable to rebuild cart item.');
        }

        return data;
      });
    });
  }

  // Re-adds the main product without expedited properties after the addon is removed.
  function rebuildMainItemWithoutExpedited(mainItem) {
    var rebuiltProperties = stripExpeditedProperties(mainItem.properties || {});
    var rebuiltItem = {
      id: mainItem.id,
      quantity: mainItem.quantity
    };

    if (Object.keys(rebuiltProperties).length) {
      rebuiltItem.properties = rebuiltProperties;
    }

    return postCartAdd({
      items: [rebuiltItem]
    });
  }

  // Triggers the theme cart refresh flow after bundled cart changes complete.
  function rebuildCartUI(cart) {
    if (
      document.body.classList.contains('template-cart') &&
      cart &&
      cart.item_count === 0 &&
      !state.redirectingToCartPage
    ) {
      state.redirectingToCartPage = true;
      window.location.href = getCartPageUrl();
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        cart: cart
      }
    }));

    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  // Patches theme.cart.changeItem so removing bundled items also cleans up their pair.
  function patchCartChangeItem() {
    if (!window.theme || !theme.cart || theme.cart._expeditedBundlePatched) {
      return;
    }

    var originalChangeItem = theme.cart.changeItem.bind(theme.cart);

    theme.cart.changeItem = function(key, qty) {
      var nextQty = parseInt(qty, 10);

      if (Number.isNaN(nextQty) || nextQty !== 0) {
        return originalChangeItem(key, qty);
      }

      return theme.cart.getCart().then(function(cart) {
        var targetItem = (cart.items || []).find(function(item) {
          return item.key === key;
        });

        if (!targetItem || !getBundleId(targetItem)) {
          return originalChangeItem(key, qty);
        }

        var bundleId = getBundleId(targetItem);
        var bundledItems = (cart.items || []).filter(function(item) {
          return getBundleId(item) === bundleId;
        });
        var mainItem = bundledItems.find(function(item) {
          return getBundleRole(item) === CONFIG.mainRole;
        });
        var addonItem = bundledItems.find(function(item) {
          return getBundleRole(item) === CONFIG.addonRole;
        });

        if (getBundleRole(targetItem) === CONFIG.addonRole) {
          var removeAddonPromise = addonItem ? originalChangeItem(addonItem.key, 0) : Promise.resolve(cart);

          return removeAddonPromise.then(function() {
            if (!mainItem) {
              return theme.cart.getCart();
            }

            return originalChangeItem(mainItem.key, 0).then(function() {
              return rebuildMainItemWithoutExpedited(mainItem);
            }).then(function() {
              return theme.cart.getCart();
            });
          });
        }

        var removeSequence = Promise.resolve();

        if (addonItem && addonItem.key !== targetItem.key) {
          removeSequence = removeSequence.then(function() {
            return originalChangeItem(addonItem.key, 0);
          });
        }

        return removeSequence.then(function() {
          return originalChangeItem(targetItem.key, 0);
        }).then(function() {
          return theme.cart.getCart();
        });
      });
    };

    theme.cart._expeditedBundlePatched = true;
  }

  // Intercepts cart remove links and routes bundled item removals through the patched logic.
  function initRemoveLinks() {
    document.addEventListener('click', function(event) {
      var removeLink = event.target.closest('.cart__remove a');
      if (!removeLink) {
        return;
      }

      var cartItem = removeLink.closest('.cart__item');
      if (!cartItem || !cartItem.dataset.key || state.removeLoading || !window.theme || !theme.cart) {
        return;
      }

      event.preventDefault();

      state.removeLoading = true;
      cartItem.classList.add('is-loading');

      theme.cart.changeItem(cartItem.dataset.key, 0)
        .then(function(cart) {
          rebuildCartUI(cart);
        })
        .catch(function() {
          window.location.href = removeLink.href;
        })
        .finally(function() {
          state.removeLoading = false;
          cartItem.classList.remove('is-loading');
        });
    });
  }

  onReady(function() {
    initProductBlocks();
    patchCartChangeItem();
    initRemoveLinks();
  });
})();

